import styled from "@emotion/styled";

import LogoIcon from "./icon-logo.svg";

export const Container = styled.div`
  inline-size: 74px;
  block-size: 30px;
  padding-block-start: 7px;
  padding-inline: 7px;

  text-align: center;

  border: 1px solid #001246;
  border-radius: 2px;
`;

export const StyledLogo = styled(LogoIcon)`
  inline-size: 58px;
  block-size: 17px;
  path {
    transition: fill 0.2s ease-in-out;
  }
`;
